<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-no" id="pt-1"><a id="page_1"><strong><span class="smallcaps">I</span><br/>C<span class="smallcaps">HICAGO</span> J<span class="smallcaps">EWS AND THE</span> S<span class="smallcaps">ECULAR</span> C<span class="smallcaps">ITY:</span> B<span class="smallcaps">UILDERS,</span> M<span class="smallcaps">OVERS,</span> S<span class="smallcaps">HAKERS</span></strong></a></h1><a id="page_1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Part01.vue?1e388ff2